import React from 'react';
import styled from 'styled-components';

const formatDate = (iso) => {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleDateString(undefined, { day: 'numeric', month: 'long', year: 'numeric' });
  } catch (e) {
    return iso;
  }
};

// Rendered inside the admin screens when the API answers
// 402 ORGANIZATION_SUSPENDED (plan §5.7 / decision 5).
const SuspendedNotice = ({ data, vocabulary }) => {
  const org = data?.organization || {};
  const name = org.name || vocabulary?.organizationNoun || 'This organization';
  const reason = data?.reason;
  const noun = (vocabulary?.organizationNoun || 'Organization').toLowerCase();

  let detail = `The ${noun}'s SmrtStats access is currently switched off.`;
  if (reason === 'expired' && org.access_ends_at) {
    detail = `The agreed access period ended on ${formatDate(org.access_ends_at)}.`;
  } else if (reason === 'expired') {
    detail = 'The agreed access period has ended.';
  }

  return (
    <Box role="alert">
      <Title>{name}'s SmrtStats access has ended</Title>
      <Body>{detail} Every player of the {noun} has lost access to the Player App until it is switched back on.</Body>
      <Body>
        To renew, contact SmrtStats at{' '}
        <a href="mailto:support@smrtstats.com">support@smrtstats.com</a>
        {org.contact_email ? <> or your {noun} contact at <a href={`mailto:${org.contact_email}`}>{org.contact_email}</a></> : null}.
      </Body>
    </Box>
  );
};

export default SuspendedNotice;

const Box = styled.div`
  background: rgba(255, 80, 80, 0.08);
  border: 1px solid rgba(255, 80, 80, 0.4);
  border-radius: 12px;
  padding: 20px 22px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  a { color: ${(p) => p.theme.green}; }
`;

const Title = styled.h2`
  margin: 0;
  font-size: 18px;
  font-family: 'SatoshiBold', sans-serif;
  color: ${(p) => p.theme.white};
`;

const Body = styled.p`
  margin: 0;
  color: ${(p) => p.theme.blueish2};
  font-size: 14px;
  line-height: 1.6;
`;
